/* Draft-only product accordion copy refresh. */
(() => {
  const VERSION = '2026-08-20-v2';

  const shippingHtml = `
    <div class="pz-accordion-rewrite pz-accordion-rewrite--shipping">
      <p class="pz-accordion-lead"><strong>Made to order, then shipped.</strong> Every personalized item needs a little production time before it begins its journey to you.</p>

      <div class="pz-accordion-shipping-grid" aria-label="Production and shipping estimates">
        <div class="pz-accordion-shipping-card pz-accordion-shipping-card--production">
          <span>Production</span>
          <strong>2–5 business days</strong>
        </div>
        <div class="pz-accordion-shipping-card">
          <span>United States &amp; Canada</span>
          <strong>4–8 business days</strong>
        </div>
        <div class="pz-accordion-shipping-card">
          <span>UK, Europe &amp; Australia</span>
          <strong>5–10 business days</strong>
        </div>
        <div class="pz-accordion-shipping-card">
          <span>Other destinations</span>
          <strong>7–14 business days</strong>
        </div>
      </div>

      <div class="pz-accordion-callout">
        <span class="pz-accordion-callout__icon" aria-hidden="true">✈</span>
        <p><strong>Tracking is emailed once your order ships.</strong> You’ll receive a tracking link at the email address used at checkout.</p>
      </div>

      <p class="pz-accordion-note">Shipping estimates begin <strong>after production</strong>. Business days exclude weekends. Carrier delays, customs, severe weather, and peak-season volume can occasionally add extra time after dispatch.</p>
      <a class="pz-accordion-link" href="/pages/shipping-and-return">View full Shipping &amp; Returns details <span aria-hidden="true">→</span></a>
    </div>`;

  const guaranteeHtml = `
    <div class="pz-accordion-rewrite pz-accordion-rewrite--guarantee">
      <p class="pz-accordion-lead">Your personalized item should arrive <strong>exactly as ordered and in good condition.</strong> If something isn’t right, contact us and we’ll help make it right.</p>

      <div class="pz-accordion-guarantee-box">
        <span class="pz-accordion-guarantee-box__label">Our promise</span>
        <strong>Free replacement or full refund</strong>
        <p>If your item arrives <b>damaged, defective, or incorrect</b> compared with the order you submitted, send us your order number and clear photos. For a qualifying issue, we’ll arrange a free replacement or full refund — <b>no return needed.</b></p>
      </div>

      <ul class="pz-accordion-checks">
        <li>Damaged on arrival</li>
        <li>Manufacturing or print defect</li>
        <li>Incorrect item or personalization compared with your submitted order</li>
      </ul>

      <div class="pz-accordion-personalized-note">
        <strong>Personalized-item note</strong>
        <p>Because personalized products are made specifically for your order, change-of-mind requests and customer-entered personalization, size, or variant choices are generally not eligible for return once production has started.</p>
      </div>

      <div class="pz-accordion-actions">
        <a class="pz-accordion-link" href="/pages/satisfaction-guarantee">Read our full Guarantee <span aria-hidden="true">→</span></a>
        <a class="pz-accordion-link pz-accordion-link--secondary" href="/pages/contact">Contact support</a>
      </div>
    </div>`;

  const normalize = (value) => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');

  const rewrite = () => {
    const root = document.querySelector('.product__info-container');
    if (!root) return false;

    let shippingDone = false;
    let guaranteeDone = false;

    root.querySelectorAll('.product-accordion-item').forEach((item) => {
      const title = item.querySelector('.accordion-title');
      const content = item.querySelector('.accordion-content');
      if (!title || !content) return;

      const label = normalize(title.textContent);

      if (label === 'shipping information') {
        shippingDone = true;
        if (content.dataset.pzAccordionCopy !== `shipping-${VERSION}`) {
          content.innerHTML = shippingHtml;
          content.dataset.pzAccordionCopy = `shipping-${VERSION}`;
        }
      }

      if (label === 'satisfaction guarantee') {
        guaranteeDone = true;
        if (content.dataset.pzAccordionCopy !== `guarantee-${VERSION}`) {
          content.innerHTML = guaranteeHtml;
          content.dataset.pzAccordionCopy = `guarantee-${VERSION}`;
        }
      }
    });

    return shippingDone && guaranteeDone;
  };

  const boot = () => {
    rewrite();
    window.setTimeout(rewrite, 350);
    window.setTimeout(rewrite, 1200);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', rewrite);
  window.addEventListener('pageshow', rewrite);
})();
